import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';
import {toInt} from '../library/math';

const CodeReviewCategories       = () => import('../views/codereview/CodeReviewCategorys.vue');
const CodeReviewEdit             = () => import('../views/codereview/CodeReviewEdit.vue');
const CodeReviewList             = () => import('../views/codereview/CodeReviewList.vue');
const CodeReviewProtocolManagers = () => import('../views/codereview/CodeReviewProtocolManagers.vue');
const CodeReviewView             = () => import('../views/codereview/CodeReviewView.vue');

const meta: MetaData = {
    module: 'code-review',
};

let routes: RouteRecordRaw[] = [
    {
        path: '/code-review',
        redirect: {
            name: 'code-review-list',
        },
    },
    {
        name: 'code-review-list',
        path: '/code-review/list',
        component: CodeReviewList,
        meta,
    },
    {
        name: 'code-review-view',
        path: '/code-review/view/:id',
        alias: [
            '/code-review/view/id/:id',
        ],
        component: CodeReviewView,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: toInt(route.params?.id),
            };
        },
    },
    {
        name: 'code-review-edit',
        path: '/code-review/edit/:id',
        alias: [
            '/code-review/edit/id/:id',
            '/code-review/entry/edit/id/:id',
            '/code-review/entry/edit/:id',
        ],
        component: CodeReviewEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            const id = toInt(route.params?.id);

            return {
                id,
                creation: id === 0,
            };
        },
    },
    {
        name: 'code-review-add',
        path: '/code-review/add',
        alias: [
            '/code-review/entry/add',
        ],
        component: CodeReviewEdit,
        meta,
        props()
        {
            return {
                id: 0,
                creation: true,
            };
        },
    },
    {
        name: 'code-review-categories',
        path: '/code-review/categories',
        alias: [
            '/code-review/category/categories',
            '/code-review/category',
        ],
        component: CodeReviewCategories,
        meta,
    },
    {
        name: 'code-review-protocol-managers',
        path: '/code-review/protocol-manager',
        alias: '/code-review/protocol-manager/index',
        component: CodeReviewProtocolManagers,
        meta,
    },
    /* compatibility routes */
    {
        path: '/code-review/list',
        redirect: {
            name: 'code-review-list',
        },
    },
    {
        path: '/code-review/categories',
        redirect: {
            name: 'code-review-categories',
        },
    },
    {
        path: '/code-review/protocol-manager',
        redirect: {
            name: 'code-review-protocol-managers',
        },
    },
    {
        path: '/code-review/protocol-manager/index',
        redirect: {
            name: 'code-review-protocol-managers',
        },
    },
    {
        path: '/code-review/category/categories',
        redirect: {
            name: 'code-review-categories',
        },
    },
    {
        path: '/code-review/entry/edit/:id',
        redirect: {
            name: 'code-review-edit',
        },
    },
    {
        path: '/code-review/entry/edit/id/:id',
        redirect: {
            name: 'code-review-edit',
        },
    },
    {
        path: '/code-review/entry/view/:id',
        redirect: {
            name: 'code-review-view',
        },
    },
    {
        path: '/code-review/entry/view/id/:id',
        redirect: {
            name: 'code-review-view',
        },
    },
    {
        path: '/code-review/:wildcard*',
        redirect: {
            name: 'code-review-list',
        },
    },
];

export default routes;
